import { render, staticRenderFns } from "./ComparativeTable.vue?vue&type=template&id=b9535cca&scoped=true"
import script from "./ComparativeTable.js?vue&type=script&lang=js&external"
export * from "./ComparativeTable.js?vue&type=script&lang=js&external"
import style0 from "./ComparativeTable.scss?vue&type=style&index=0&id=b9535cca&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9535cca",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotIcon: require('/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Atoms/Icon/Icon.vue').default})
